import axios from "axios";
import Config from "../config"
import { useLoginStore } from '../stores/login';
// const store = useLoginStore();

export default class GroupService {
  constructor() {
    this.loginStore = null;
  }

  store() {
    if(!this.loginStore) { this.loginStore = useLoginStore(); };
    return this.loginStore;
  }
  
  async getGroups() {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{},
      },
    }
    return await axios
      .get(
        Config.url("groups"),
        options
      ).then(res => { return res.data });
  }
  async getGroupById(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .get(
        Config.url("single_group") + "?groupId=" + id,
        options
      ).then(res => { return res.data });
  }
  async createGroup(values) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .post(
        Config.url("createGroup"),
        values,
        options
      ).then(res => { return res.data });
  }
  async deleteGroup(id) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };
    return await axios
      .delete(
        Config.url("deleteGroup") + "?groupId=" + id,
        options
      ).then(res => { return res.data });
  }
  async setSingleGroup(values) {
    const options = {
      headers: {
        ...Config.headers(this.store().getAccessToken), ...{}
      }
    };

    return await axios
      .patch(
        Config.url("updateGroup"),
        values,
        options
      ).then(res => { return res.data });
  }
}